import React, { useMemo } from 'react';
import { createStringFilterFunction } from '../../components/table/functions/createStringFilterFunction';
import { AdminTableInputFilter } from '../../components/table/filters/AdminTableInputFilter';
import { AdminTableColumn } from '../../components/table/interfaces/AdminTableColumn';
import { Customer } from '../dto/Customer';
import { createBooleanFilterFunction } from '../../components/table/functions/createBooleanFilterFunction';
import { AdminTableBooleanFilter } from '../../components/table/filters/AdminTableBooleanFilter';
import { CustomersAssets } from '../CustomersAssets';
import { useTranslation } from 'react-i18next';
import { AdminDate } from '../../components/table/AdminDate';
import { createDateFilterFunction } from '../../components/table/functions/createDateFilterFunction';
import { AdminTableDateFilter } from '../../components/table/filters/AdminTableDateFilter';

export function useCustomerColumns(): AdminTableColumn<Customer>[] {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        title: t('Name').toString(),
        predicate: (item) => item.name,
        sortingPredicate: (item) => item.name,
        filterConfig: {
          filter: createStringFilterFunction((item) => item.name),
          component: AdminTableInputFilter,
        },
      },
      {
        title: t('Taken assets').toString(),
        predicate: (item) => <CustomersAssets customer={item} />,
        sortingPredicate: (item) => item.assets.length,
        filterConfig: {
          filter: createBooleanFilterFunction((item) => !!item.assets.length),
          component: AdminTableBooleanFilter,
        },
      },
      {
        title: t('Created at'),
        predicate: (item) => <AdminDate date={item.createdAt} />,
        sortingPredicate: (item) => item.createdAt,
        filterConfig: {
          filter: createDateFilterFunction((item) => item.createdAt),
          component: AdminTableDateFilter,
        },
        style: {
          width: 160,
        },
      },
    ],
    [t],
  );
}
